export const CREATE_CUSTOMER_PORTAL_SESSION = gql`
  mutation createCustomerPortalSession($workspaceId: String!) {
    createCustomerPortalSession(workspaceId: $workspaceId)
  }
`

export const CREATE_SUBSCRIPTION = gql`
  mutation createSubscription(
    $workspaceId: String!
    $tiers: [SubscriptionTierInput!]!
  ) {
    createSubscription(workspaceId: $workspaceId, tiers: $tiers) {
      id
      current
    }
  }
`

export const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscription(
    $workspaceId: String!
    $tiers: [SubscriptionTierInput!]!
  ) {
    updateSubscription(workspaceId: $workspaceId, tiers: $tiers)
  }
`

export const DELETE_SUBSCRIPTION = gql`
  mutation deleteSubscription($workspaceId: String!) {
    deleteSubscription(workspaceId: $workspaceId)
  }
`

export const DELETE_CUSTOMER = gql`
  mutation deleteCustomer($workspaceId: String!) {
    deleteCustomer(workspaceId: $workspaceId)
  }
`

export const CREATE_ASSISTANT_AUTHORIZATION_REQUEST = gql`
  mutation createAssistantAuthorizationRequest(
    $workspaceId: String!
    $userId: String!
    $tierId: String!
    $businessCase: String
  ) {
    createAssistantAuthorizationRequest(
      workspaceId: $workspaceId
      userId: $userId
      tierId: $tierId
      businessCase: $businessCase
    ) {
      id
    }
  }
`

export const APPROVE_ASSISTANT_AUTHORIZATION_REQUEST = gql`
  mutation approveAssistantAuthorizationRequest(
    $workspaceId: String!
    $assistantAuthorizationRequestId: String!
  ) {
    approveAssistantAuthorizationRequest(
      workspaceId: $workspaceId
      assistantAuthorizationRequestId: $assistantAuthorizationRequestId
    ) {
      id
    }
  }
`

export const DENY_ASSISTANT_AUTHORIZATION_REQUEST = gql`
  mutation denyAssistantAuthorizationRequest(
    $workspaceId: String!
    $assistantAuthorizationRequestId: String!
  ) {
    denyAssistantAuthorizationRequest(
      workspaceId: $workspaceId
      assistantAuthorizationRequestId: $assistantAuthorizationRequestId
    ) {
      id
    }
  }
`

export const ADD_ASSISTANT_AUTHORIZATION = gql`
  mutation addAssistantAuthorization(
    $workspaceId: String!
    $tierId: String!
    $email: String
    $userId: String
  ) {
    addAssistantAuthorization(
      workspaceId: $workspaceId
      tierId: $tierId
      email: $email
      userId: $userId
    ) {
      id
      tierId
      userId
      assistantId
      adminId
      email
    }
  }
`

export const REMOVE_ASSISTANT_AUTHORIZATION = gql`
  mutation removeAssistantAuthorization(
    $workspaceId: String!
    $assistantAuthorizationId: String!
  ) {
    removeAssistantAuthorization(
      workspaceId: $workspaceId
      assistantAuthorizationId: $assistantAuthorizationId
    )
  }
`

export const CHANGE_ASSISTANT_AUTHORIZATION_TIER = gql`
  mutation changeAssistantAuthorizationTier(
    $workspaceId: String!
    $assistantAuthorizationId: String!
    $tierId: String!
  ) {
    changeAssistantAuthorizationTier(
      workspaceId: $workspaceId
      assistantAuthorizationId: $assistantAuthorizationId
      tierId: $tierId
    ) {
      id
    }
  }
`
